import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAFXXOKgCfyVWnnlF6sv8X_wUmz2jTKRQ4",
  authDomain: "codiq-c724d.firebaseapp.com",
  projectId: "codiq-c724d",
  storageBucket: "codiq-c724d.appspot.com",
  messagingSenderId: "705672230968",
  appId: "1:705672230968:web:e1c54833004575fc304ecd",
  measurementId: "G-CEXCZ7BY2G",
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
